module.exports = require("./bo.js");